import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useFormContext } from "react-hook-form";

interface Props {
  open: boolean;
  setOpen: (opened: boolean) => void;
  prenesiJavniKljuc: () => void;
}

const Index = ({ open, setOpen, prenesiJavniKljuc }: Props) => {
  const { watch } = useFormContext();
  const certifikatPostoji = watch("certifikatPostoji");
  const javniKljucPostoji = watch("certifikat");

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Potvrda</DialogTitle>
      <DialogContent>
        {((certifikatPostoji && !javniKljucPostoji) ||
          (certifikatPostoji &&
            javniKljucPostoji &&
            javniKljucPostoji.size === 0)) &&
          "Već postoji prenesena CSR datoteka. Prijenosom nove datoteke prijašnja datoteka prestaje vrijediti. Želite li prenijeti novu CSR datoteku?"}
        {javniKljucPostoji &&
          javniKljucPostoji.size > 0 &&
          "Već postoji potvrđena CSR datoteka i izdan certifikat. Prijenosom nove CSR datoteke izdan certifikat prestaje vrijediti i čeka se potvrđivanje CSR datoteke."}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Ne</Button>
        <Button onClick={prenesiJavniKljuc}>Da</Button>
      </DialogActions>
    </Dialog>
  );
};

export default Index;
